import React from 'react';
import PropTypes from 'prop-types';

const NoStudents = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={color}
      d="m18.965 17.56-4.082-1.054c.729-.593 1.239-1.318 1.385-2.24.51-.132.875-.659.875-1.318 0-.197-.073-.395-.073-.527l.364-2.568c0-.066.146-1.318-.948-2.438-.874-.922-2.405-1.383-4.373-1.383-1.969 0-3.427.461-4.375 1.383-1.093 1.054-.947 2.372-.947 2.438l.364 2.569c-.073.131-.073.329-.073.526 0 .66.365 1.12.875 1.318.073.922.656 1.713 1.458 2.306l-4.228.988C3.875 18.02 3 19.14 3 20.458v1.713c0 .197.146.329.365.329h17.568c.22 0 .365-.132.365-.33v-1.712c-.073-1.317-.948-2.437-2.333-2.898ZM8.25 7.876c.802-.79 2.114-1.185 3.864-1.185s3.061.395 3.79 1.12c.875.856.73 1.91.73 1.91l-.292 1.976c-.073 0-.146-.066-.219-.066l-.364-1.515c0-.132-.22-.263-.365-.263-2.26 0-2.697-.593-2.916-.989.073-.065 0-.197-.073-.263a.379.379 0 0 0-.51 0c-.146.066-.219.198-.292.33-.219.395-.656.987-2.916.987-.146-.065-.291.066-.364.198l-.292 1.515c-.073 0-.146.066-.219.066L7.52 9.72s-.073-.988.729-1.845Zm.437 6.06c0-.197-.146-.329-.364-.329-.365 0-.51-.46-.51-.724 0-.264.072-.725.51-.725.145 0 .291-.132.364-.263l.292-1.45c2.041 0 2.697-.46 3.135-1.054.437.593 1.093 1.054 3.134 1.12l.292 1.45c0 .131.219.263.364.263.365 0 .51.461.51.724 0 .264-.072.725-.51.725-.218 0-.364.132-.364.33 0 .988-.73 1.778-1.531 2.37a.578.578 0 0 0-.292.133c-.583.395-1.239.593-1.676.593-.365 0-1.021-.198-1.604-.527-.073-.066-.146-.066-.219-.132-.802-.593-1.53-1.45-1.53-2.503Zm3.427 4.81c-.438 0-.802-.33-.802-.725v-.461c.291.066.583.131.802.131.218 0 .51-.066.801-.131v.46c0 .396-.364.725-.801.725Zm-8.384 1.712c0-1.054.656-1.91 1.677-2.306l4.665-1.12c.146.067.292.198.51.264v.79c0 .527.365 1.055.875 1.252l-1.822 2.503H3.729v-1.383Zm6.78 1.383 1.604-2.174 1.603 2.174H10.51Zm9.987 0h-5.905l-.948-1.284-.947-1.285c.51-.197.874-.724.874-1.251v-.79c.22-.067.365-.198.584-.33l4.52 1.186c1.093.329 1.75 1.251 1.75 2.305v1.45h.072Z"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.9}
      d="m19.468 3.973-3.513 1.601-3.806-.914-3.66.8-3.66-1.487L12.15 1l7.32 2.973Z"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeWidth={0.8}
      d="M17.377 7.404c0-1.516-2.847-2.287-5.228-2.287-2.38 0-5.228.771-5.228 2.287"
    />
    <path stroke={color} strokeLinecap="square" strokeWidth={0.4} d="M18.945 3.745v2.653" />
    <path
      fill={color}
      d="M18.757 6.601a.2.2 0 0 1 .38 0l.637 1.912a.2.2 0 0 1-.19.264H18.31a.2.2 0 0 1-.19-.264l.638-1.912Z"
    />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.373}
      fill={color}
      stroke="#fff"
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.373)"
    />
  </svg>
);

NoStudents.propTypes = {
  color: PropTypes.string
};

export default NoStudents;
